import { makeStyles } from 'tss-react/mui';

const name = 'RequestsMap';

export const useRequestsMapStyles = makeStyles({ name })(theme => ({
  root: {
    position: 'relative',

    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(7.5),

    padding: theme.spacing(7.5),

    borderRadius: theme.shape.borderRadiusLg,
    border: `1px solid ${theme.palette.divider}`,

    background: theme.palette.background.paper,

    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(4),
    },

    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(5),
    },
  },
  loading: {
    height: theme.spacing(2 * 26),
  },
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    display: 'flex',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
  mapContainer: {
    position: 'relative',
    width: '100%',
    marginBottom: theme.spacing(2 * -3),

    '& path:focus': {
      outline: 'none',
    },
  },
}));
